import { complement } from 'ramda';

import isNull from './isNull';

/**
 * Checks if input value is complement of `null`.
 *
 * @func isNotNull
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/0.1.0|v0.1.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNull|isNull}
 * @example
 *
 * RA.isNotNull(1); //=> true
 * RA.isNotNull(undefined); //=> true
 * RA.isNotNull(null); //=> false
 */
var isNotNull = /*#__PURE__*/complement(isNull);

export default isNotNull;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/isNotNull.js
// module id = 139
// module chunks = 0